import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { createContext, useContext, useMemo, useState } from "react";
var CustomCssContext = createContext({
    customCss: "",
    setCustomCss: function () { return undefined; },
});
export var CustomCssContextProvider = function (_a) {
    var children = _a.children;
    var _b = useState(""), customCss = _b[0], setCustomCss = _b[1];
    var value = useMemo(function () { return ({ customCss: customCss, setCustomCss: setCustomCss }); }, [customCss]);
    return _jsx(CustomCssContext.Provider, { value: value, children: children });
};
export var useCustomCss = function () { return useContext(CustomCssContext); };
